import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment.dev";
import { BaseService } from "../../@core/services/base.service";
import { HttpClient } from "@angular/common/http";
import { IClient, ITagType, ILocation, IScopeOfWork, TAG_TYPES, ITypeOfContract, ITag, IRepoExtracted, IDocumentType } from "../models/settings.model";
import { TAG_DATA_TYPES } from "../../@core/models/enums";

@Injectable({ providedIn: 'root' })
export class TagsService extends BaseService {

    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }


    apiUrl = environment.apiUrl + '/tag';

    downloadSampleExcelForTags() {
        return this.get<{ data: Buffer }>(this.apiUrl + '/sample-excel-tag-types')
    }

    uploadExcelForTagTypes(data: FormData) {
        return this.post<{ buffer?: { data: Buffer } }>(this.apiUrl + '/upload-excel-tag-types', data)
    }

    getTagTypes(body: { filters?: { searchValue?: string, dataType?: TAG_DATA_TYPES[], documentType?: IDocumentType['_id'], page?: number, limit?: number }, getLinkedTags?: boolean }) {
        return this.post<{ tagTypes: ITagType[], linkedTags: { [key: string]: ITag[] }, total?: number }>(this.apiUrl + '/tag-types', body);
    }

    getTags(filters: { tag?: ITagType['_id'], searchValue?: string }) {
        return this.post<ITag[]>(this.apiUrl, filters)
    }

    saveTagType(tagType: ITagType, confirmedEdit: boolean = false) {
        return this.post(this.apiUrl + '/save-tag-type', { tagType, confirmedEdit })
    }
    deleteTagType(tagTypeId: ITagType['_id']) {
        return this.delete(this.apiUrl + '/tag-type/' + tagTypeId)
    }
    addTagsFromRepo(data: { tags: IRepoExtracted[], type: ITag['type'], tagType: ITag['tagType'] }) {
        return this.post<ITag[]>(this.apiUrl + '/repo', data)
    }

    saveTag(tag: IClient | ILocation | ITypeOfContract | IScopeOfWork | null) {
        return this.put(this.apiUrl, tag)
    }

    deleteTag(tagId: string) {
        return this.delete(this.apiUrl + '/' + tagId)
    }

    downloadSampleExcelForTagValues() {
        return this.get<{ data: Buffer }>(this.apiUrl + '/sample-excel-tags')
    }

    uploadExcelForTagValues(data: FormData) {
        return this.post<{ buffer?: { data: Buffer } }>(this.apiUrl + '/upload-excel-tags', data)
    }
}